import { ECasinoGameMode } from 'interfaces/casino-data';
import { fetchGamesByIds } from 'services/casino/casino-fetch-games-by-id';
import { useOpenCasinoGame } from 'newhooks/casino/useOpenCasinoGame';

export const useOpenGameCustomCode = () => {
  const openGame = useOpenCasinoGame();

  return (gameId: string, mode: ECasinoGameMode) => {
    fetchGamesByIds([gameId], true, true).then(data => {
      if (data.length) {
        const game = data[0];

        openGame(mode, game);
      }
    });
  };
};
